document.addEventListener("DOMContentLoaded", function () {
  if (window?.location?.pathname === "/cart") {
    const standardBuyBtn = document?.querySelector(
      ".cart__footer--buttons button[type='submit']"
    );
    const shopBtnGroup = document?.querySelector(
      "shopify-accelerated-checkout-cart"
    ).childNodes;

    setTimeout(() => {
      if (standardBuyBtn !== null && shopBtnGroup) {
        const policyBtn = document.getElementById("terms-try");
              if (!policyBtn) {
        // no terms checkbox → leave buttons enabled
        return;
      }

        const testValue = document?.querySelector(
          ".cart__footer--buttons button[type='submit']"
        );

        const removeNode = document?.querySelectorAll(
          "[is='cart-remove-item']"
        );
        const qtyNodes = document?.querySelectorAll(".quantity__button");

        testValue.disabled = true;
        shopBtnGroup.forEach((node) => {
          node.disabled = true;
        });

        policyBtn?.addEventListener("click", () => {
          toggleButtons(policyBtn);
        });
        removeNode.forEach((node) => {
          node.addEventListener("click", () => {
            toggleButtons(policyBtn);
          });
        });

        qtyNodes.forEach((node) => {
          node.addEventListener("click", () => {
            toggleButtons(policyBtn);
          });
        });
      }
    }, 800);

    const observer = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (
          mutation.type === "childList" &&
          mutation.target.classList.contains("cart__footer--buttons")
        ) {
          const policyBtn = document.getElementById("terms-try");
          toggleButtons(policyBtn);

          policyBtn?.addEventListener("click", () => {
          toggleButtons(policyBtn);
        });
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    function toggleButtons(state) {
      // If there is no terms checkbox, we treat checkout as allowed
      const shouldDisable = state ? !state.checked : false;

      const shopBtnGroup = document
        ?.querySelector("shopify-accelerated-checkout-cart")
        ?.childNodes;

      const secondTestValue = document?.querySelector(
        ".cart__footer--buttons button[type='submit']"
      );

      if (secondTestValue) {
        secondTestValue.disabled = shouldDisable;
      }

      if (shopBtnGroup) {
        shopBtnGroup.forEach((node) => {
          if ("disabled" in node) {
            node.disabled = shouldDisable;
          }
        });
      }
    }

  }
});
